document.addEventListener('DOMContentLoaded', () => {
  const loadMoreButton = document.getElementById('load-more');
  const productGrid = document.getElementById('product-grid');
  const viewAllLink = '/collections'; // Link to view all products
  let currentPage = 1; // Initial page

  function showViewAllProductsDiv() {
    // Check if the "View All Products" div already exists
    if (!document.querySelector('.view-all-products')) {
      const viewAllDiv = document.createElement('div');
      viewAllDiv.className = 'view-all-products';
      viewAllDiv.innerHTML = `
        <div style="text-align: center; margin-top: 20px;">
          <a href="${viewAllLink}" class="view-all-button">View All Collections</a>
        </div>
      `;
      productGrid.parentNode.appendChild(viewAllDiv);
      console.log("View All Products button added.");
    }
  }

  loadMoreButton.addEventListener('click', () => {
    currentPage++;
    loadMoreButton.disabled = true;
    loadMoreButton.textContent = 'Loading...';

    fetch(`${window.location.pathname}?page=${currentPage}&section_id=main-collection-product-grid`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to load products.');
        }
        return response.text();
      })
      .then((responseText) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(responseText, 'text/html');
        const newProducts = doc.querySelector('#product-grid')?.innerHTML || '';
          console.log(newProducts,"newProducts")
        if (newProducts.trim() === '') {
          // No more products to load
          loadMoreButton.style.display = 'none';
          showViewAllProductsDiv();
        } else {
          productGrid.insertAdjacentHTML('beforeend', newProducts);
          loadMoreButton.disabled = false;
          loadMoreButton.textContent = 'Load More';
        }
      })
      .catch((error) => {
        console.error('Error loading more products:', error);
        loadMoreButton.disabled = false;
        loadMoreButton.textContent = 'Load More';
      });
  });
});
